import styled from "styled-components";

export const Section = styled.div`
  display: grid;
  row-gap: 2rem;
  grid-template-rows: 1fr 1fr;
  border-bottom: 1px solid #3d3d3d;
  padding: 1.5rem;

  p {
    margin-top: 0.3rem;
    color: var(--grey-100);
    font-size: 0.95rem;
  }

  &:last-of-type {
    border-bottom: 0px;

    padding-top: 1.5rem;
   
    div:last-of-type {
      display:flex;
      flex-direction:row;
      margin-left:auto;
      gap:1rem;

      div:last-of-type {
        margin-top:4px;
      }
    }
  }
`;
export const IDCDiv = styled.div`
  display:flex;
  flex-direction:row;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;

  button {
    width: fit-content;
    padding: 0 1rem;
    width: 25rem;
  }
`;

export const Badge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  position: relative;
  margin-bottom: 0.8rem;
  width: 100%;
  padding: 0.5625rem 0.75rem;
  border-radius: 6.25rem;
  font-size: 0.85rem;
  font-family: DM Sans;
  min-height: 2rem;
  color: var(--green);
  background: rgba(71, 212, 68, 0.1);
`;
